import type { AppLocale } from "./index"
import type { ExtendedLocale } from "./extendedLocaleUi"
import { isSpecialLocale } from "./specialLocales"

export function isExtendedLocale(locale: AppLocale): locale is ExtendedLocale {
  return locale === "be" || locale === "hy" || locale === "ka" || locale === "ky" || locale === "tg" || isSpecialLocale(locale)
}
